import React, { useRef, useEffect } from 'react';
import { observer } from 'mobx-react';
import './LandLevelingSummary.scss';
import stores from '../../../models/Stores';
import { LandLevelingSummaryVM } from './LandLevelingSummaryVM';
import { Table } from 'reactstrap';
import { Notification } from '../../common/Notification/Notification';
import { ActionsMenu } from 'cd-eft/components/Design/common/ActionsMenu';
import { DesignSummaryButtons } from 'cd-eft/components/Design/common/DesignSummaryButtons';
import Icon from '@mdi/react';
import { mdiAlertCircleOutline } from '@mdi/js';
const { landLevelingDesignStore, designStore } = stores.AppStore;

const LandLevelingSummaryComponent = (props) => {
  const vm = useRef(new LandLevelingSummaryVM(props)).current;

  useEffect(() => {
    // Land Leveling requires a surface, need to check for surfaceDefId first and
    // gets design elements if we have project with session
    // we may want to move this request up to the parent component which handles getting the project
    // this could avoid this useEffect on a store variable
    vm.initLandLeveling();
  }, [designStore.currentSurface.surfaceDefId]);

  return (
    <div className="land-leveling-summary">
      {vm.error && vm.errorMsg ? (
        <div className="mt-3 err error-message">
          <h3 className="usa-error-message" id="client--message" role="alert">
            {vm.errorMsg}
          </h3>
        </div>
      ) : null}

      {!vm.error && !vm.errorMsg ? (
        <div className="design-summary-table">
          <Table className="set-table">
            <thead>
              <tr>
                <th className="narrow-td">Select</th>
                <th>Id</th>
                <th>Name</th>
                <th>Design Type</th>
                <th className="narrow-td">Actions</th>
              </tr>
            </thead>
            <tbody>
              {landLevelingDesignStore.landLevelingSummaryTable.map((item: any, i) => {
                return i < landLevelingDesignStore.landLevelingSummaryTable.length ? (
                  <tr key={'key' + item.designElementId}>
                    <td className="text-center">
                      <input
                        id={'key' + item.designElementId}
                        data-testid="selectDesignElementId"
                        name="keySelect"
                        type="checkbox"
                        aria-label={
                          'id: ' +
                          item.designElementId +
                          ', name: ' +
                          item.designElementName +
                          ' , design type: ' +
                          item.designElementTypeId?.name
                        }
                        checked={item.checked}
                        value={item.id}
                        onChange={(event) => {
                          vm.handleCheckboxChange(event, i, true);
                        }}
                      />
                    </td>
                    <td>{item.designElementId}</td>
                    <td>{item.designElementName}</td>
                    <td>
                      <div className="design-type"> {item.designElementTypeId?.name}
                        {item.flagUpToDate && (
                          <div className="flag-up-todate"><span className="warning-span"> (Invalid) </span>
                            <div className="hover-text"><Icon path={mdiAlertCircleOutline} color="#ac2e36" size={1.2} />
                              <span className="tooltip-text" id="bottom">The structure is no longer valid because the base surface/survey has changed</span>
                            </div></div>
                        )}</div>
                    </td>
                    <td>
                      <ActionsMenu i={i} item={item} elementActions={vm.elementActions} />
                    </td>
                  </tr>
                ) : null;
              })}
            </tbody>
          </Table>
          {landLevelingDesignStore.landLevelingSummaryTable.length === 0 && !landLevelingDesignStore.showLoader ? (
            <div className="h4 m-5 text-center">Add your first Land Leveling</div>
          ) : null}
        </div>
      ) : null}
      <DesignSummaryButtons
        panel="Design"
        disableAdd={false}
        disableRefreshElements={vm.jobExecuting || landLevelingDesignStore.landLevelingSummaryTable.length === 0}
        disableRebuildSurface={vm.jobExecuting || landLevelingDesignStore.landLevelingSummaryTable.length === 0}
        buttontype={vm.displayType === 'surface'}
        add={vm.addDesign}
        refreshElements={vm.displaySelectedLandLeveling}
        rebuildSurface={() => vm.onClickSurface()}
      />
      <Notification
        type={vm.notification.type}
        message={vm.notification.message}
        header={vm.notification.header}
        hidden={vm.notification.hidden}
        timestamp={vm.notification.timestamp}
      />
    </div>
  );
};

export const LandLevelingSummary = observer(LandLevelingSummaryComponent);
